import React from 'react';
import { practiceBenefits } from '../data/content';
export function Practice() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-177" data-mp="18n7sf2qpce53">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="18lxuqenrh7yz">
        <div className="mx-auto max-w-2xl text-center" data-id="element-179" data-mp="1dmc2dvlgafwh">
          <h2 className="font-display text-3xl font-black leading-tight text-navy-800 sm:text-4xl" data-id="element-180" data-mp="1dkr6o2negqx1">
            Was dir die Sammlung im{' '}
            <span className="text-gold-dark" data-id="element-181" data-mp="kyojckztvxby">Trainingsalltag</span> bietet
          </h2>
        </div>

        <dl className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-182" data-mp="pwq3l98zq2p0">
          {practiceBenefits.map((benefit, index) => <div key={benefit.title} className="flex h-full flex-col rounded-xl border border-slate-200 bg-slate-50 p-6" data-id="element-183" data-mp="uvb3t8o8smdg" data-mpi={index}>
              <span aria-hidden="true" className="font-display text-sm font-black text-gold-dark" data-id="element-184" data-mp="27opb5dh7xbt">
                {String(index + 1).padStart(2, '0')}
              </span>
              <dt className="mt-3 font-display text-lg font-extrabold leading-snug text-navy-800" data-id="element-185" data-mp="3m65864zlfgc7">
                {benefit.title}
              </dt>
              <dd className="mt-auto pt-3 text-sm leading-relaxed text-slate-600" data-id="element-186" data-mp="3h7al2qulf5ma">
                {benefit.description}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}